module.exports = __webpack_public_path__ + "static/media/MHRP77N0009.497992b8.svg";